import {
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from "@mui/material";
import { SectionTitle } from "./commons";

export default function InsomniaRiskContent4() {
  return (
    <>
      <Stack sx={{ gap: "16px" }}>
        <SectionTitle
          text="参考情報：各睡眠測定データの分布"
          subtext="※縦軸は全て晩数"
        />
        <Stack sx={{ gap: "14px" }}>
          <Stack direction="row" sx={{ justifyContent: "space-between" }}>
            <DistributionChart
              title="総就床時間の分布"
              unitText="(単位：時間)"
              src="/img/image_insomnia_risk_distribution_chart_01.png"
            />
            <DistributionChart
              title="睡眠時間の分布"
              unitText="(単位：時間)"
              src="/img/image_insomnia_risk_distribution_chart_02.png"
            />
          </Stack>
          <Stack direction="row" sx={{ justifyContent: "space-between" }}>
            <DistributionChart
              title="総睡眠時間の分布"
              unitText="(単位：時間)"
              src="/img/image_insomnia_risk_distribution_chart_03.png"
            />
            <DistributionChart
              title="睡眠効率の分布"
              unitText="(単位：%)"
              src="/img/image_insomnia_risk_distribution_chart_04.png"
            />
          </Stack>
          <Stack direction="row" sx={{ justifyContent: "space-between" }}>
            <DistributionChart
              title="入眠潜時の分布"
              unitText="(単位：分)"
              src="/img/image_insomnia_risk_distribution_chart_05.png"
            />
            <DistributionChart
              title="離床潜時の分布"
              unitText="(単位：分)"
              src="/img/image_insomnia_risk_distribution_chart_06.png"
            />
          </Stack>
          <Stack direction="row" sx={{ justifyContent: "space-between" }}>
            <DistributionChart
              title="中途覚醒時間の分布"
              unitText="(単位：分)"
              src="/img/image_insomnia_risk_distribution_chart_07.png"
            />
            <DistributionChart
              title="覚醒回数の分布"
              unitText="(単位：回)"
              src="/img/image_insomnia_risk_distribution_chart_08.png"
            />
          </Stack>
        </Stack>

        <PreconditionTable />
      </Stack>
    </>
  );
}

interface DistributionChartProps {
  title: string;
  unitText: string;
  src: string;
}

function DistributionChart({ title, unitText, src }: DistributionChartProps) {
  return (
    <Stack sx={{ gap: "6px" }}>
      <Typography
        sx={{
          color: "#707070",
          fontSize: "11.5px",
          fontWeight: 500,
          "& sub": {
            fontSize: "8px",
            fontWeight: 500,
            ml: "4px",
            verticalAlign: "baseline",
          },
        }}
      >
        {title}
        <sub>{unitText}</sub>
      </Typography>
      <img
        src={src}
        alt={title}
        loading="lazy"
        style={{ width: "353px", height: "170px" }}
      />
    </Stack>
  );
}

function PreconditionTable() {
  const cellStyle = {
    border: "solid #000",
    borderWidth: "0px 1px 1px 0px !important",
    fontSize: "10px",
    fontWeight: "400",
    height: "32px",
    p: 0,
    pl: "8px",
    width: "245px",
  };
  const titleCellStyle = {
    ...cellStyle,
    fontWeight: "500",
    width: "120px",
    backgroundColor: "#EAEAEA80",
  };

  // 測定データの前提情報
  const preconditions = {
    // N 数
    n: 1130,
    // 平均年齢
    ageAverage: "47.3歳（9歳～77歳）",
    // 測定晩数
    measurementAtNightCount: 6970,
    // 性別
    gender: "男性 64% / 女性 36%",
  };

  return (
    <Stack sx={{ gap: "12px" }}>
      <Typography
        sx={{
          fontSize: "11.5px",
          fontWeight: 500,
          color: "#707070",
        }}
      >
        測定データの前提情報
      </Typography>
      <TableContainer
        sx={{
          border: "solid #000",
          borderWidth: "1px 0px 0px 1px",
          borderRadius: 0,
        }}
      >
        <Table>
          <TableBody>
            <TableRow>
              <TableCell sx={titleCellStyle}>N数</TableCell>
              <TableCell sx={cellStyle}>{preconditions.n}</TableCell>
              <TableCell sx={titleCellStyle}>平均年齢</TableCell>
              <TableCell sx={cellStyle}>{preconditions.ageAverage}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell sx={titleCellStyle}>測定晩数</TableCell>
              <TableCell sx={cellStyle}>
                {preconditions.measurementAtNightCount}
              </TableCell>
              <TableCell sx={titleCellStyle}>性別</TableCell>
              <TableCell sx={cellStyle}>{preconditions.gender}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Stack>
  );
}
